<template>
  <td>
    <template v-if="!value">
      -
    </template>
    <template v-else-if="isDaily">
      <span>매일</span>
    </template>
    <template v-else>
      <span>매주 </span>
			<span :class="styles">{{dayOfWeekText}}</span>
    </template>
		<slot/>
  </td>
</template>

<script>
export default {
  props: {
    value: Object,
		styles: {
      type: String,
			default: 'type_block',
    }
  },
  computed: {
    isDaily() {
      return this.value.period === "DAILY";
    },
    dayOfWeekText() {
      if (this.isDaily) return false;
      const dayArr = "월화수목금토일".split("");
      return this.value.dayOfWeek
        .reduce((resultArr, val, i) => {
          if (val) resultArr.push(dayArr[i]);
          return resultArr;
        }, [])
        .join(", ");
    }
  }
};
</script>

<style>
</style>
